import axios from "axios";
import { shallow } from 'zustand/shallow';

import { IsEmptyOrNullOrUndefined } from "@helpers/Utils";
import { useQuery } from "@tanstack/react-query";

import useStoreUserRoles from './_storeUserRoles';

const ARCHEM_URL = process.env.REACT_APP_API_URL + "login/";
const getState = state => ({ username: state.username, application: state.application });
export const keysUserRoles = {
  all: [{ scope: 'user.roles' }],
  getUsersRoles: (user) => [{ ...keysUserRoles.all[0], user }],
  getUserAllowedApps: (user) => [{ ...keysUserRoles.all[0], user, entity: 'allowed.apps' }],
  getUserRolesAndAllowedApps: (user) => [{ ...keysUserRoles.all[0], user, entity: 'roles.and.allowed.apps' }],
}


export const useGetUserRolesForApplication = () => {
  const _store = useStoreUserRoles(getState, shallow);

  const getData = async ({ queryKey: [{ user }] }) => {
    const { data } = await axios.get(ARCHEM_URL + 'getuserrolesforapp', { params: { user } });
    return data;
  }

  return useQuery(keysUserRoles.getUsersRoles(_store.username), getData, { enabled: !IsEmptyOrNullOrUndefined(_store.username) });
}

export const useGetUserRolesAndAllowedApplication = (_user = '') => {
  const _store = useStoreUserRoles(getState, shallow);

  const getData = async ({ queryKey: [{ user }] }) => {
    const { data } = await axios.get(ARCHEM_URL + 'GetUserRolesAndAllowedApps', { params: { user } });
    return data;
  }

  return useQuery(keysUserRoles.getUserRolesAndAllowedApps(_store.username), getData, { enabled: !IsEmptyOrNullOrUndefined(_store.username) });
}

export const useGetUserAllowedApplications = () => {
  const _store = useStoreUserRoles(getState, shallow);
  const getData = async ({ queryKey: [{ user }] }) => {
    const { data } = await axios.get(ARCHEM_URL + 'getuserallowedapplications', { params: { user } });
    return data;
  }

  return useQuery(keysUserRoles.getUserAllowedApps(_store.username), getData, { enabled: !IsEmptyOrNullOrUndefined(_store.username) });
}